import React from 'react';
import { LinkedInIcon } from '../components/common/icons';
import lindaPhoto from '../assets/employees/linda-ceo.jpg';
import danPhoto from '../assets/employees/dan-cto.jpg';

// Botanical corner silhouettes — same leaf fan as the landing page's
// pricing band (pages/Home.js), filled with currentColor tints.
const CornerLeaves = ({ className }) => (
  <svg viewBox="0 0 200 200" fill="currentColor" className={className} aria-hidden="true">
    <path d="M14 198 C 10 130 22 66 52 26 C 44 92 36 150 30 198 Z" />
    <path d="M36 198 C 52 140 92 92 148 74 C 104 116 72 160 58 200 Z" opacity=".7" />
    <path d="M4 156 C 2 118 8 84 28 58 C 20 96 14 128 12 158 Z" opacity=".55" />
  </svg>
);

const TEAM = [
  {
    name: 'Linda Pettersen Myhre',
    role: 'CEO, eier og medgründer',
    photo: lindaPhoto,
    linkedin: 'https://www.linkedin.com/in/lukra-linda/',
  },
  {
    name: 'Dan Vegar Sletten',
    role: 'CTO, eier og medgründer',
    photo: danPhoto,
    linkedin: 'https://www.linkedin.com/in/dan-vegar-sletten/',
  },
];

const About = () => {
  return (
    <div className="max-w-[680px] mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold text-sage mb-10">Om Coord</h1>

      {/* Mission */}
      <section className="mb-10">
        <p className="text-text-primary leading-relaxed mb-4">
          Når barnet ditt får en diagnose, starter en ny hverdag, og ofte en kamp mot et system som er vanskelig å forstå. Coord finnes fordi vi mener at ingen foreldre skal måtte bli eksperter på byråkrati for å gi barnet sitt den hjelpen det har krav på.
        </p>
        <p className="text-text-primary leading-relaxed">
          Vi bygger verktøy som gjør det enklere å søke om stønader fra Nav. Ikke ved å forenkle reglene, men ved å guide deg gjennom dem, steg for steg, på en måte som er tilpasset akkurat din situasjon.
        </p>
      </section>

      {/* Hvem vi er */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-sage mb-4">Hvem vi er</h2>
        <p className="text-text-primary leading-relaxed mb-4">
          Coord er et lite, uavhengig selskap basert i Askim, Norge. Vi er ikke en del av Nav eller det offentlige, men et privat initiativ som brenner for å gjøre velferdsystemet mer tilgjengelig for familier som trenger det mest.
        </p>
        <p className="text-text-primary leading-relaxed">
          Vi bygger Coord i tett dialog med foreldre, fagpersoner og brukere av Navs tjenester.
        </p>
      </section>

      {/* Kvalitet */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-sage mb-4">Slik sikrer vi kvalitet</h2>
        <p className="text-text-primary leading-relaxed mb-4">
          Informasjonen i Coord er basert på Navs offisielle rundskriv, lover og retningslinjer. Vår AI henter kontekst direkte fra disse kildene for å gi deg relevante og oppdaterte svar.
        </p>
        <p className="text-text-primary leading-relaxed">
          Vi er likevel tydelige: Coord erstatter ikke juridisk rådgivning. Har du en komplisert sak, anbefaler vi alltid å snakke med en fagperson eller kontakte Nav direkte.
        </p>
      </section>

      {/* Teamet — lush gradient cards in the landing pricing band's palette */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-sage mb-4">Teamet</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {TEAM.map(({ name, role, photo, linkedin }) => (
            <div
              key={name}
              className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-50 via-background-warm to-sage-100 px-6 py-8"
            >
              <div
                aria-hidden="true"
                className="absolute -top-10 -right-8 w-36 h-36 rounded-full bg-primary-200/50 blur-2xl"
              />
              <div
                aria-hidden="true"
                className="absolute -bottom-12 -left-10 w-40 h-40 rounded-full bg-sage-200/60 blur-2xl"
              />
              <CornerLeaves className="absolute -bottom-2 -left-1 w-24 h-24 text-sage-300/80" />
              <CornerLeaves className="absolute -top-2 -right-1 w-20 h-20 rotate-180 text-primary-200/90" />
              <div className="relative flex flex-col items-center text-center">
                <img
                  src={photo}
                  alt={`Portrett av ${name}`}
                  className="w-24 h-24 rounded-full object-cover ring-4 ring-background-white shadow-md"
                />
                <h3 className="mt-4 font-semibold text-text-primary">{name}</h3>
                <p className="mt-1 text-sm text-text-secondary">{role}</p>
                <a
                  href={linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} på LinkedIn`}
                  className="mt-3 p-2.5 rounded-full text-text-muted hover:text-primary-600 transition-colors duration-200"
                >
                  <LinkedInIcon className="w-5 h-5" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer info */}
      <footer className="border-t border-border-light pt-6 text-sm text-text-muted">
        <p>Coord AS</p>
        <p>Org.nr: 933 971 376</p>
        <p>Askim, Norge</p>
      </footer>
    </div>
  );
};

export default About;
